<template>
  <basic-container>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      id="project20211203"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
      @refresh-change="onLoad"
      :upload-preview="uploadPreview"
      :upload-before="uploadBefore"
      :before-close="beforeClose"
    >
  <template slot-scope="scope" slot="menu">
       <el-button
            type="text"
            size="small"
            icon="el-icon-edit"
            v-if="permissionList.wxConfigParam"
            @click="wxConfig(scope.row)"
            >微信配置
          </el-button>
          <!-- <el-button
            type="text"
            size="small"
            icon="el-icon-delete"
          
            @click="removeRecord(scope.row.id)"
            >删除
          </el-button> -->
      </template>
    <!-- <template slot="menuLeft">
              <Form ref="form" ></Form>
            </template> -->
      <template slot="chargeManId" slot-scope="{row}">
        <span>{{ row.realName }}</span>
      </template>
      <template slot="chargeManIdForm">
        <choice-people
          ref="choicePeopleRef"
          :limit="1"
          :allUserList="realInspectManList"
          :list="list"
          :remainUserListInside.sync="realInspectManList"
          :projectId="form.projectId"
          :disabled="!form.deptId||fileDisabled"
          message="请选责任人"
        ></choice-people>
      </template>
      <template slot="deptIdForm">
        <avue-input-tree
          ref="treeselect"
          :disabled="fileDisabled"
          style="width:100%"
          :props="treeDeptProps"
          v-model="form.deptId"
          placeholder="请选择 所属机构"
          type="tree"
          :dic="deptList"
          @change="deptChange"
        ></avue-input-tree>
      </template>

      <!--            <template slot="menuLeft">-->
      <!--                <el-button type="danger"-->
      <!--                           size="small"-->
      <!--                           icon="el-icon-delete"-->
      <!--                           plain-->
      <!--                           v-if="permission.project_delete"-->
      <!--                           @click="handleDelete">删 除-->
      <!--                </el-button>-->
      <!--            </template>-->
      <template slot-scope="{ row }" slot="status">
        <el-tag :type="row.status === 1 ? 'success' : 'danger'">{{ row.status === 0 ? '停用' : '正常' }}</el-tag>
      </template>
      <template slot="attachIdsForm" slot-scope="scope">
        <VUpload
          :disabled="fileDisabled"
          message="提示：只能上传jpg/png文件，且"
          messageType="pre"
          :types="['jpg', 'png']"
          :limit="10"
          :fileList.sync="attachList"
        ></VUpload>
      </template>
    </avue-crud>

       <hr-dialog title="微信配置" :allowFull="false" width="35%" :visible.sync="configVisible">
      <template slot="body">
           <el-form
      :model="configForm"
      ref="formRef"
      :rules="formRules"
      label-suffix=":"
      label-width="100px"
    >
      <el-row :gutter="24">
        <el-col :span="24">
          <el-form-item label="公众号appId" prop="code">
              <el-input
              clearable
              show-word-limit
              v-model="configForm.mpAppId"

             
              placeholder="公众号appId"
             
              maxlength="32"
            
            ></el-input>
           
          <!-- <el-input-number  style="width:100%" size="small" v-model="configForm.code" @blur="inspectCode"  :min="1" :max='9999999' label="请输入充电桩编号"></el-input-number> -->
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="小程序appId" prop="areaId">
              <el-input
              clearable
              show-word-limit
              v-model="configForm.maAppId"

           
              placeholder="小程序appId"
             
              maxlength="32"
            
            ></el-input>
          </el-form-item>
        </el-col>
       
        
        <el-col :span="24">
          <div style="float:right">
            <el-button
              type="primary"
              icon="el-icon-circle-plus-outline"
              @click="submitConfig"
              size="small"
            >
              保存
            </el-button>
            <!-- <el-button icon="el-icon-circle-close" @click="cancleRecord" size="small">
              下载
            </el-button> -->
          </div>
        </el-col>
      </el-row>
    </el-form>
      </template>
    </hr-dialog>
  </basic-container>
</template>

<script>
import VUpload from '@/views/components/v-upload.vue';
import {
  add,
  getDetail,
  getList,
  remove,
  update,
  getUserlist,
  treeByIds,
  wxParamSubmit,
  wxParamDetail
} from '@/api/crmedical/project/project';
import { mapGetters } from 'vuex';
import projectOption from './project-option';
import { getAttachByMainIdList } from '@/api/crmedical/attach/attach';
import { Base64 } from 'js-base64';
import settings from '@/config/vd-settings';
import { getToken } from '@/util/auth';
import choicePeople from '@/components/user-edit-box/user-edit-box3';
import { setTimeout } from 'timers';
import Form from './project-form'
export default {
  components: {
    VUpload,
    choicePeople,
    Form
  },
  data: function() {
    return {
      configForm:{

      },
      configVisible:false,
      serachFlag :true,
      deptList: [],
      realInspectManList: [],
      remainUserList: [],
      pageMode: 1,
      form: {},
      query: {},
      headers: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      option: projectOption,
      attachList: [],
      fileDisabled: false,
      data: [],
      treeDeptProps: {
        labelText: '标题',
        label: 'title',
        value: 'id',
        children: 'children',
      },
      list: [],
      //渲染页面后列表得长度
      todoListLength: 10000000000000000,
    };
  },
  watch: {
    'nearby.center.lng'() {
      console.log(this.nearby.center.lng);
    },
    realInspectManList: {
      handler() {
        if (this.realInspectManList.length > 0) {
          console.log(this.realInspectManList[0]);
          this.$set(this.form, 'chargeManId', this.realInspectManList[0].id);

          this.form.chargeManName = this.realInspectManList[0].realName;
          this.$forceUpdate();
        }
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.project_add, false),
        viewBtn: this.vaildData(this.permission.project_view, false),
        delBtn: this.vaildData(this.permission.project_delete, false),
        editBtn: this.vaildData(this.permission.project_edit, false),
         wxConfigParam: this.vaildData(this.permission.project_wx_param, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  created() {
    this.headers['Authorization'] = `Basic ${Base64.encode(
      `${settings.clientId}:${settings.clientSecret}`
    )}`;
    // 让每个请求携带token--['Authorization']为自定义key 请根据实际情况自行修改
    this.headers['Blade-Auth'] = 'bearer ' + getToken();
    treeByIds().then((res) => {
      console.log('res', res);
      this.deptList = res.data;
    });
    this.option.height = this.bodyHeight - 398;
    console.log(this.option.height, this.bodyHeight);
  },
  mounted() {
    //console.log(this.$refs.crud.$children[0].$children[0].$children[0].$children[0].$children[0].$children[0].$children[0].$children[5].$children[0].$children[0].$children[1]);
    console.log('1111111111111=>', this.$refs.crud.$children[4]);

    //通过识别页面里面分页栏的高度来改变页面option的高度，有bug，搜索空项目时，第一次识别不到option高度的变化，第二次才恢复正常
    this.$nextTick(() => {
      this.reWrite = true;
      setTimeout(() => {
        this.$refs.crud.$children[1].$children[3].$el.addEventListener('click', () => {
          console.log(this.todoListLength);
          console.log(this.option.height, this.bodyHeight);
          this.clickChangeHeight()

          onLoad();
        });
      });
    });
  },
  methods: {
    submitConfig(){
        wxParamSubmit(this.configForm).then(res=>{
          this.configVisible = false
          this.$message.success('保存配置成功')
        })
    },
    wxConfig(row){
      console.log('row',row)
      wxParamDetail({
        projectId	:row.id	
      }).then(res =>{
        this.configForm = res.data
         this.configForm.projectId = row.id
         this.configForm.id = res.data.id == '-1'?'':res.data.id
         this.configVisible = true
      })
    },
    onLoadChangeHeight(){

    },
    clickChangeHeight(){
      this.serachFlag = !this.serachFlag;
          if (this.todoListLength === 0) {
            if (this.option.height == this.bodyHeight - 398 + 32) {
              this.option.height = this.bodyHeight - 287 + 32;
            } else {
              this.option.height = this.bodyHeight - 398 + 32;
            }
          } else {
            if (this.option.height == this.bodyHeight - 398) {
              this.option.height = this.bodyHeight - 287;
            } else {
              this.option.height = this.bodyHeight - 398;
            }
          }

          this.$refs.crud.getTableHeight();
    },
    changeStyle(){
          console.log('beforeOpen=>', this.$refs.crud.$children[4].$children[0].$refs.dialog.children[1]);
          let dom = this.$refs.crud.$children[4].$children[0].$refs.dialog.children[1]
          dom.id = "project20211207"
          let projectAvue = document.querySelector('#project20211207 .avue-form__group--flex')
          console.log(projectAvue);
          const child = document.createElement('div')
          child.setAttribute('style','height:67px; width:100%')
          projectAvue.appendChild(child)
    },
    deptChange(val, node) {
      console.log(val, node);
      console.log(this.$refs.treeselect);
      console.log(this.$refs.treeselect.$refs.tree.getNode(val));
      this.list = this.$refs.treeselect.$refs.tree.getNode(val).data;
      this.form.chargeManId = ''
      this.form.chargeManName = ''
      this.realInspectManList = []
    },
    beforeClose(done, type) {
      this.attachList = [];
      this.form = [];
      // this.form.attachIds = '';
      this.fileDisabled = false;
      done();
    },
    uploadBefore(file, done, loading) {
      let len = file.name.split('.').length;
      console.log(file.type === 'image/jpeg' || file.type === 'image/png');
      console.log(file.type);
      const isImage =
        (file.name.split('.')[len - 1] === 'png' || file.name.split('.')[len - 1] === 'jpg') &&
        (file.type === 'image/jpeg' || file.type === 'image/png');
      console.log(isImage);
      const isLt500KB = file.size / 1024 < 500;
      if (!isImage) {
        this.$message.error('只能上传jpg/png格式的图片');
        loading();
        return;
      }
      if (!isLt500KB) {
        this.$message.error('上传图片大小不能超过500kb!');
        loading();
        return;
      }
      if (isImage && isLt500KB) {
        done();
      }
    },
    rowSave(row, loading, done) {
      let arrs = this.attachList.map(item => {
        return item.id;
      });
      row.attachIds = arrs.join(',');
      add(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowUpdate(row, index, loading, done) {
      let arrs = this.attachList.map(item => {
        return item.id;
      });
      row.attachIds = arrs.join(',');
      update(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      setTimeout(() => {
        this.changeStyle()
         
      }, 0);
    
  
 

      // let self = this;
      //  getUserlist ().then(({data}) => {
      //     if (data){
      //       self.$refs.crud.$children[4].formOption.dicData['chargeManId']=data;
      //     }
      //
      //   });
      done();
      // if (["add"].includes(type)){
      //   this.form.deptId = 1123598813738675201;
      // }
      this.realInspectManList = [];

      if (['edit', 'view'].includes(type)) {
        console.log('form', this.form);
        if (this.form.chargeManId) {
          let obj = {
            id: this.form.chargeManId,
            realNameAndPhone: this.form.realName,
            realName: this.form.realName,
          };
          this.realInspectManList.push(obj);
        }

        getAttachByMainIdList({ mainId: this.form.id }).then(({ data }) => {
          if (data) {
            data.forEach((item) => {
              item.url = item.link;
            });
            this.attachList = data;
          }
        });
        if (['view'].includes(type)) {
          console.log('查看');
          this.fileDisabled = true;
        }
        setTimeout(() => {
          getDetail({ id: this.form.id }).then(({ data }) => {
            this.form = data;
          });
        }, 0);
      } else {
        if (['view'].includes(type)) {
          console.log('查看');
          this.fileDisabled = true;
        }
      }
    },
    searchReset() {
      this.query = {};
      this.onLoad();
    },
    searchChange(params, done) {
      // console.log('搜索了',params);
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
        ({ data }) => {
          console.log(data.records.length);
      
          this.todoListLength = data.records.length;
          console.log(this.todoListLength);
          if(this.serachFlag){
               if (data.records.length === 0) {
                  this.option.height = this.bodyHeight - 398 + (78 - 46);
                  console.log('this.bodyHeight - 398+(78-46)');
                } else {
                  this.option.height = this.bodyHeight - 398;
                  console.log('this.bodyHeight - 398');
                }
                this.$refs.crud.getTableHeight();
          }
          this.page.total = data.total;
          this.data = data.records;
          this.data.forEach((item) => {
            item.deptId2 = item.deptId;
          });
          this.loading = false;
          this.selectionClear();
        }
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.map {
  width: 100%;
  height: 100%;
}
.search-map {
  position: absolute;
  top: 40px;
  z-index: 3000;
}
::v-deep .avue-form__menu--center {
  text-align: right;
}
::v-deep .avue-crud__search .el-form-item--small.el-form-item {
  width: 100%;
}



// /deep/ .el-dialog__body {
//   background: red;
// }
</style>>

<style>
#project20211203 .el-form-item__content {
  padding-right: 5px !important;
}
#project20211203 .avue-form__row {
  padding-right: 5px !important;
}

#project20211207 {
  /* background: red; */
  padding-right: 24px !important;
  position: relative;
  height: 100%;
}

#project20211207  .avue-form__menu--right{
  /* background: greenyellow; */
  position: absolute;
  bottom: 0;
}

#project20211207  .el-textarea__inner{
  font-size: 13px;
}

</style>
